/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TractorBeamGameModuleConfig} from "./TractorBeamGameModuleConfig";

export class TractorBeam extends SlotGame {

    constructor() {
        super(TractorBeamGameModuleConfig.instance);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M3",
                    "M2",
                    "L3"
                ],
                [
                    "L2",
                    "L4",
                    "L1"
                ],
                [
                    "M3",
                    "W",
                    "M2"
                ],
                [
                    "M3",
                    "L3",
                    "M1"
                ],
                [
                    "M4",
                    "L4",
                    "M2"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWins": 0,
            "scatterSymbolWin": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "removedSymbols": [],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "randomFeatureTriggered": false,
            "numberOfExtraFreespinsAwarded": 0,
            "scatterExtraSpinPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "randomStackedTriggered": false,
            "randomStackedOverlayReels": [
                false,
                false,
                false,
                false,
                false
            ]
        };
    }
}
